// extracted by mini-css-extract-plugin
export default {"container":"GlobalNavigationEmptyCard_container__Y2QzM","emptyCard":"GlobalNavigationEmptyCard_emptyCard__ODRiN"};